
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'

import {ReservationResponse} from '../../../lib/kepler/interfaces'
import VehicleQuickSummary from '../vehicle/VehicleQuickSummary.vue'
import DateHelper from '../../../lib/DateHelper'
import Layout from '../../proxy/Layout.vue'
import Flex from '../../proxy/Flex.vue'
import ServiceMesh from '../../../lib/serviceMesh'
import FuelLevel from '../../FuelLevel.vue'
import Divider from '../../proxy/Divider.vue'
import Container from '../../proxy/Container.vue'
import Card from '../../proxy/Card/Card.vue'
import CardTitle from '../../proxy/Card/CardTitle.vue'
import Utils from '@/utils'

@Component({
  components: {
    VehicleLotAndDistance: Utils.loadComponent('entities/vehicle/VehicleLotAndDistance'),
    CardTitle, Card, Container, Divider, FuelLevel, Flex, Layout, VehicleQuickSummary,
  },
  name: 'ReservationVehicleAndDates',
})
export default class ReservationVehicleAndDates extends Vue {
  @Action('openPopup') public openPopup!: any
  @Prop() public reservation!: ReservationResponse | null
  @Prop() public hideParkingLot!: boolean
  @Prop() public hideStatus!: boolean

  get fuelImage() {
    if (this.vehicleSlot) {
      return ServiceMesh.getImageForFuelLevel(this.vehicleSlot.vehicle)
    }
  }

  /**
   * bm RT || (started && confirmed)
   */

  get fuelLevel() {
    if (this.vehicleSlot) {
      return this.vehicleSlot.vehicle.fuel_level === null ? 0 : this.vehicleSlot.vehicle.fuel_level
    }
  }

  get startDate() {
    if (this.reservation !== null && this.reservation.start) {
      return DateHelper.formatDate(this.reservation.start, 'D MMM YYYY')
    }
  }

  get endDate() {
    if (this.reservation !== null && this.reservation.end) {
      return DateHelper.formatDate(this.reservation.end, 'D MMM YYYY')
    }
  }

  get bookingMode() {
    if (this.vehicleSlot) {
      return this.vehicleSlot.reservation_type
    }
  }

  get vehicleSlot() {
    return this.reservation?.vehicle_slot
  }
}
